

































import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import Icon from '../../../../../../components/Icon/Icon.vue'
import Tags from '../../../../../../components/Tags/Tags.vue'
import { warningNotificationWrapper } from '../../../../../../logic/helpers/NotificationService'
import { MessageEditorComponentSettings } from "../../../../types";
import TopicsSelect from './TopicsSelect.vue'

@Component({
  components: {
    TopicsSelect,
    Icon,
    Tags
  }
})
export default class Topics extends Vue {
  @Prop() topics!: Array<number>

  @Prop({ type: Object }) topicsOptions!: MessageEditorComponentSettings['topics']

  @Prop() options?: Record<string, any>

  @Prop() disabled!: boolean

  @Emit()
  update(): this {
    return this
  }

  @Emit()
  setTopics(topics: Array<number>): Array<number> {
    return topics
  }

  pickTopic(id: number): void {
    if (this.topics.includes(id)) {
      this.topics
        .splice(this.topics.indexOf(id), 1)
    } else {
      this.selectTopic(id)
    }
  }

  selectTopic(id: number): void {
    if (this.topicsOptions) {
      if (this.topicsOptions.limit === 1) {
        this.setTopics([ id ])
      } else {
        if (this.topics.length < this.topicsOptions.limit) {
          this.setTopics([
            ...this.topics,
            id
          ])
        } else {
          warningNotificationWrapper(this.$t('warning').toString(), 'Достигнут лимит по топикам')
        }
      }
    }
  }
}
